
import { Nullable } from '@/shared/types/app.types'

export interface LocalAutomationPortionsComboParsing {
    id: number
    description: string
}

export interface LocalAutomationPortionsModalComboElement {
    id: number
    text: string
}

export interface LocalAutomationPortionsModalCombo {
    list: LocalAutomationPortionsModalComboElement[]
    selected: Nullable<LocalAutomationPortionsModalComboElement>
}

export interface LocalAutomationPortionsModalState {
    id: Nullable<number>
    active: boolean
    numberOfPortionsToGenerate: number
    sampleTypes: LocalAutomationPortionsModalCombo
    portionTypes: LocalAutomationPortionsModalCombo
    topographicCodes: LocalAutomationPortionsModalCombo
    procedures: LocalAutomationPortionsModalCombo
}
export const initialLocalAutomationPortionsModalState =
    (): LocalAutomationPortionsModalState => ({
        id: null,
        active: true,
        numberOfPortionsToGenerate: 1,
        sampleTypes: {
            list: [],
            selected: null
        },
        topographicCodes: {
            list: [],
            selected: null
        },
        procedures: {
            list: [],
            selected: null
        },
        portionTypes: {
            list: [],
            selected: null
        }
    })
